import React from 'react';
import ImageGallerreferencebooks from '../components/ImageGallerreferencebooks';
// import IRCTVDonationCard from "./IRCTVDonationCard";


const IRCPRODUCTION = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerreferencebooks />

                    {/* Women Empowerment Programs */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>
                                REFERENCE BOOKS LIBRARY</h3>
                        </div>
                        <div className="activity-content">
                            <p>

                                IRC hosts its own library containing thousands of books on Religion, History, General Knowledge, Science etc. Books on religion include Islam, Christianity, Judaism, Hinduism, Zoroasterism, Buddhism, Jainism, Sikhism, Taoism, Confucianism & others in various languages like Arabic, English, Urdu, Sanskrit, Pali, Hindi, Marathi, Gujrati, Telgu, Kannadi, Malayalam, etc.
                            </p>

                            <p>

                                The library and its facilities are open for both males and females of all faiths.


                            </p>
                        </div>
                        {/* <IRCTVDonationCard
                            title="REFERENCE BOOKS LIBRARY"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: REFERENCE BOOKS LIBRARY"
                        /> */}
                    </div>

                </section>
            </div>
        </>
    );
};

export default IRCPRODUCTION;
